module.exports = __webpack_public_path__ + "img/logo-black.c7cb6994.svg";